import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Chip } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ProductActionsFormatter = ({ handleClickAdd, row, panelsIdsData }) => {
    const { t } = useTranslation();
    return (
        <Box>
            {panelsIdsData.includes(row?.id) ? (
                <Chip
                    color="success"
                    icon={<CheckCircleIcon fontSize="small" />}
                    label={t('Added')}
                    variant="outlined"
                    sx={{ width: 115, fontWeight: 'bold' }}
                />
            ) : (
                <Button
                    startIcon={<AddIcon fontSize="small" />}
                    onClick={() => handleClickAdd(row)}
                    variant="outlined"
                >
                    {t('Add')}
                </Button>
            )}
        </Box>
    );
};

ProductActionsFormatter.propTypes = {
    handleClickAdd: PropTypes.func,
    panelsIdsData: PropTypes.array,
    row: PropTypes.object,
};

export default ProductActionsFormatter;
